import React, { useMemo } from "react";
// This is a pure utility hook that only have React dependencies
// eslint-disable-next-line no-restricted-imports
import { DebouncedState } from "@/domains/react/useDebouncedCallback";

type DelayedHide = DebouncedState<(e?: React.MouseEvent<HTMLDivElement, MouseEvent>) => void>;

export class MDSHoverContentGroup {
  hideFns: DelayedHide[] = [];

  hideAll = ({ exceptHideFn }: { exceptHideFn?: DelayedHide }) => {
    for (const hideFn of this.hideFns) {
      if (hideFn !== exceptHideFn) {
        hideFn();
        hideFn.flush();
      }
    }
  };
}

export const useMDSHoverContentGroup = () => {
  const group = useMemo(() => new MDSHoverContentGroup(), []);
  return group;
};
